import React, { useEffect, useState, forwardRef } from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { useSelector } from "react-redux";
import { selectDirection } from "styles/theme/slice";

type EditableColumnProps = {
  value: string;
  isOdd?: boolean;
  containerStyle?: SxProps<Theme>;
  innerContainerStyle?: SxProps<Theme>;
  inputStyle?: React.CSSProperties;
  disabled?: boolean;
  maxLength?: number;
  onSave: (val: string) => void;
  onKeyUp?: (e: any) => void;
  onFocus?: (e: any) => void;
  
};

const EditableColumn = forwardRef<HTMLInputElement, EditableColumnProps>(
  (
    {
      value,
      isOdd = false,
      containerStyle,
      innerContainerStyle,
      inputStyle,
      disabled = false,
      maxLength,
      onSave,onKeyUp,onFocus
    },
    ref
  ) => {
    const direction = useSelector(selectDirection);
    const [isHovered, setIsHovered] = useState(false);

    // Determine border based on hover state
    const border = isHovered ? "1px solid #207DB9" : "1px solid #A0A0A0";

    // Handle input changes with maxLength restriction and call onSave
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = maxLength ? e.target.value.slice(0, maxLength) : e.target.value;
      onSave(newValue);
    };

    return (
      <Box
        onMouseEnter={!disabled ? () => setIsHovered(true) : undefined}
        onMouseLeave={!disabled ? () => setIsHovered(false) : undefined}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%",
          ...containerStyle,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            height: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px",
            alignSelf: "center",
            maxWidth: "150px",
            width: "100%",
            border,
            ...innerContainerStyle,
            opacity: disabled  ? 0.5 : 1, 
          }}
        >
          <input
            ref={ref}
            value={value}
            onChange={handleInputChange}
            onKeyUp={onKeyUp}
            onFocus={onFocus}
            disabled={disabled}
            style={{
              border: "none",
              outline: "none",
              fontSize: "14px",
              backgroundColor: "transparent",
              fontWeight: 500,
              lineHeight: "14px",
              color: "#5E6781",
              width: "100%",
              padding: "0px",
              margin: "0px",
              unicodeBidi: "plaintext",
              ...inputStyle,
            }}
          />
        </Box>
      </Box>
    );
  }
);

export default EditableColumn;
